import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ProcessTemplateListItemType } from '@econtractor/types';
import SpinnerBlock from 'components/others/SpinnerBlock';
import ProcessDirTableBody from './ProcessDirTableBody';

interface ProcessDirTableProps {
    templates: ProcessTemplateListItemType[];
    showSpinner: boolean;
    onSelect?: (template: ProcessTemplateListItemType) => void;
    onEdit?: (template: ProcessTemplateListItemType) => void;
    onDelete?: (template: ProcessTemplateListItemType) => void;
}

const ProcessDirTable = ({ templates, showSpinner, onSelect, onEdit, onDelete }: ProcessDirTableProps) => {
    const { t } = useTranslation(['Tasks']);
    const withActions = Boolean(onEdit || onDelete);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="ProcessDirTable table-hover mb-0">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-name">{t('processDir.colName')}</td>
                            <td className="head-category">{t('processDir.colCategory')}</td>
                            {withActions ? <td className="head-action" /> : null}
                        </tr>
                    </thead>
                    <ProcessDirTableBody
                        templates={templates}
                        colSpan={withActions ? 3 : 2}
                        onSelect={onSelect}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                </Table>
            </div>
        </div>
    );
};

export default ProcessDirTable;
